import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getAvatarText } from "../../../common";
import { memo } from "react";

function Header() {
    const { user } = useSelector((state: RootState) => state.auth);

    return (<div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex justify-center items-center text-white font-bold text-[20px]">{getAvatarText(user?.fullName || "")}</div>
            <div>
                <p className="text-slate-400 text-sm">Welcome back</p>
                <h2 className="text-white text-2xl font-bold">{user?.fullName}!</h2>
            </div>
        </div>

        <div className="flex gap-6">
            <div className="text-right">
                <h3 className="text-white text-2xl font-bold">42.5K</h3>
                <p className="text-slate-400 text-sm">Active Users</p>
            </div>
            <div className="text-right">
                <h3 className="text-white text-2xl font-bold">97.4K</h3>
                <p className="text-slate-400 text-sm">Total Users</p>
            </div>
        </div>
    </div>);
}

export default memo(Header);